export const JQL_VALIDATION_FAILED = 'JQL_VALIDATION_FAILED' as const;
